import React from "react";
import ReviseProcedureFileTbody from "../../procedureFileTbodyFields/reviseProcedureFileTbody";
import ProcedureProcessFileThead from "../../approveAndReviseFileHeadFields";
import { dataStatus, fileTags } from "../../../../../publicDictionaryValues";
import tablePublicMethods from "../../../../../commonComponents/fileManagementFields/tablePublicMethods";
import BaseFileTable from "../../../../../commonComponents/fileTables/baseFileTable";

export default class ReviseProcedureFileTable extends BaseFileTable {
  constructor(props: any) {
    super(props);
    this.state = {
      data: [],
    };
  }

  /* control table change to control save button whether disabled in approve and revise page */
  controlIsTableChange = (dataList: any) => {
    // Compare only the persisted `data` columns. Build lightweight rows that omit row-level fields
    // such as replaceRef (a live React ref that is unstable/circular and never persisted) and
    // neutralize the presentational isDisabled flag (undefined is dropped by JSON.stringify in
    // compaireTwoCircular). This keeps leftover UI state (e.g. a note disabled by delete but not
    // reset by cancel) from wrongly counting as a change and enabling Save as Draft.
    const stripUiFields = (rows: any) =>
      rows.map((row: any) => ({
        data: row.data.map((item: any) => ({ ...item, isDisabled: undefined })),
      }));
    const list = this.sortDataList(stripUiFields(dataList));
    const initList = this.sortDataList(stripUiFields(this.props.initProcedureTableData));
    const flag = !tablePublicMethods.compaireTwoCircular(list, initList);
    if (flag) {
      this.props.setIsTableChange();
    } else {
      this.props.cancelIsTableChange();
    }
  };

  /* update file table data */
  updateDataList = (dataList: any) => {
    if (!this.props.isComplete) {
      this.controlIsTableChange(dataList);
    }
    if (dataList.length === 0) {
      this.setState({ isExpendData: false });
    }
    this.setState({
      data: dataList,
    });
    this.handleDefaultExpendIcon();
  };

  /* function about set return file number in revise page */
  setReturnDataNumber = (data: any) => {
    // @ts-ignore
    this.returnNumber = 0;
    for (let index in data) {
      if (
        data[index].data.find((i: any) => i.name === "fileName").tagValue !== fileTags.deleted &&
        data[index].data.find((i: any) => i.name === "status").value === dataStatus.return &&
        data[index].data.find((i: any) => i.name === "newVersion").value === null
      ) {
        // @ts-ignore
        this.returnNumber += 1;
      }
    }
  };

  handleReturnTableTbody = (obj: any) => {
    const {
      data,
      columns,
      inputOnChange,
      procedureNoteMaxLength,
      fileSectionDisabled,
      procedureNoteSize,
      hasSubmit,
      fileTableRef,
      optionList,
      handleReturnClick,
      handleFileSelect,
      currentRole,
      downloadFile,
      isSupportingFile,
      isComplete,
      isExpendData,
      isFileTableShow,
    } = obj;
    return (
      <ReviseProcedureFileTbody
        data={data}
        columns={columns}
        inputOnChange={inputOnChange}
        procedureNoteMaxLength={procedureNoteMaxLength}
        fileSectionDisabled={fileSectionDisabled}
        procedureNoteSize={procedureNoteSize}
        hasSubmit={hasSubmit}
        fileTableRef={fileTableRef}
        optionList={optionList}
        handleReturnClick={handleReturnClick}
        handleFileSelect={handleFileSelect}
        currentRole={currentRole}
        downloadFile={downloadFile}
        isSupportingFile={isSupportingFile}
        isComplete={isComplete}
        handleChangeTableHeight={this.handleChangeTableHeight}
        isExpendData={isExpendData}
        isFileTableShow={isFileTableShow}
      />
    );
  };

  render() {
    const {
      procedureNoteMaxLength,
      fileSectionDisabled,
      procedureNoteSize,
      inputOnChange,
      hasSubmit,
      fileTableRef,
      className,
      optionList,
      handleReturnClick,
      handleFileSelect,
      pageType,
      currentRole,
      downloadFile,
      isSupportingFile,
      isComplete,
      isExpendData,
      columns,
      isFileTableShow,
    } = this.props;
    const { data } = this.state;
    this.setReturnDataNumber(data);

    return (
      <>
        <div className="scrollTable" style={{ overflowY: "hidden" }}>
          <table className={`${className} table autoHeightChangeContainer`}>
            <ProcedureProcessFileThead
              columns={columns}
              hasSubmit={hasSubmit}
              pageType={pageType}
            />
            {this.handleReturnTableTbody({
              data,
              columns,
              inputOnChange,
              procedureNoteMaxLength,
              fileSectionDisabled,
              procedureNoteSize,
              hasSubmit,
              fileTableRef,
              optionList,
              handleReturnClick,
              handleFileSelect,
              currentRole,
              downloadFile,
              isSupportingFile,
              isComplete,
              isExpendData,
              isFileTableShow,
            })}
          </table>
        </div>
        <p className={`${this.props.className} fileNumTip`} style={{ color: "#FF9921" }}>
          {/* @ts-ignore */}
          <span className="fileNum">{this.returnNumber}</span> {/* @ts-ignore */}
          {this.setFileText(this.returnNumber)} returned for revision
        </p>
      </>
    );
  }
}
